<template>
  <div v-if="loadingStatus" id="loading">
    <!-- <div class="loading-img"></div> -->

    <img
      class="loading-img"
      src="@/assets/images/common/loadingInfo.png"
      alt=""
    />
  </div>
  <div v-else id="obituary">
    <div v-if="obituaryHide">
      <ObituaryEndCover
        v-if="endModalFlag && isEndObituary"
        @close="endModalFlag = false"
      />

      <audio
        v-if="obituaryDetail && obituaryDetail.musicYn && obituaryDetail.Music"
        id="musicplayer"
        ref="musicplayer"
        autoplay
      >
        <source :src="obituaryDetail.Music.filePath" />
      </audio>

      <obituary-header
        :obituaryDetail="obituaryDetail"
        :skinBanner="skinBanner"
      />
      <obituary-main
        :obituaryDetail="obituaryDetail"
        :obituaryMembers="obituaryMembers"
        :volumeMute="volumeMute"
        @mute="handleAudioMute"
        :skinBanner="skinBanner"
        @goShop="goShop"
      />

      <div class="divider__2"></div>
      <obituary-memorial-main :obituaryDetail="obituaryDetail" @goShop="goShop" />

      <main class="pt-2">
        <section
          v-if="
            obituaryDetail &&
              obituaryDetail.Movies &&
              obituaryDetail.Movies.length > 0
          "
        >
          <div class="letter-title__wrap" style="cursor:pointer">
            <h4>함께한 순간들</h4>
          </div>

          <v-carousel
            :show-arrows="obituaryDetail.Movies.length > 1"
            height="251"
            hide-delimiters
            hide-delimiter-background
          >
            <v-carousel-item
              v-for="movie in obituaryDetail.Movies"
              :key="movie.id"
            >
              <iframe
                style="width:100%;max-width:420px;height:251px;"
                muted
                :src="movie.filePath"
              >
              </iframe>
            </v-carousel-item>
          </v-carousel>
        </section>
      </main>
    </div>
  </div>
</template>

<script src="https://www.youtube.com/iframe_api"></script>
<script>
import { mapGetters } from "vuex";

import DefaultMovie from "../../components/movie/DefaultMovie.vue";
import ObituaryEndCover from "../../components/obituary/ObituaryEndCover.vue";
import ObituaryHeader from "../../components/obituary/header/ObituaryHeader.vue";
import ObituaryMain from "../../components/obituary/Main/ObituaryMain.vue";
import ObituaryMemorialMain from "../../components/obituary/MemorialMain/ObituaryMemorialMain.vue";

export default {
  /* eslint-disable */
  name: "ObituaryPage",
  layout: "obituary",

  components: {
    DefaultMovie,
    ObituaryEndCover,
    ObituaryHeader,
    ObituaryMain,
    ObituaryMemorialMain
  },
  metaInfo() {
    return {
      title: this.dynamicTitle,
      meta: [
        {
          vmid: "og:title",
          property: "og:title",
          content: this.dynamicTitle
        },
        {
          property: "og:description",
          content: this.dynamicDescription,
          id: "og-description-value"
        }
      ]
    };
  },

  data() {
    return {
      loadingStatus: true,
      id: this.$route.query.id ? this.$route.query.id : null,
      showWreathList: false,
      showMsgList: false,

      volumeMute: false,

      dynamicTitle: "삼가 고인의 명복을 빕니다", // 동적으로 설정할 제목 데이터
      dynamicDescription: "url 링크를 클릭하면 부고장으로 이동합니다", // 동적으로 설정할 설명 데이터

      obituaryDetail: null,
      obituaryMembers: null,
      movie: null,

      endModalFlag: true,

      memberId: this.$route.query.memberId ? this.$route.query.memberId : null,
      bankOnly: this.$route.query.bankOnly ? this.$route.query.bankOnly : null,
      host: this.$route.query.host ? this.$route.query.host : null

      // sendObituary: null
    };
  },

  computed: {
    ...mapGetters(["getObituary"]),
    obituaryHide() {
      if (this.getObituary?.endDate) {
        const endDate = new Date(this.getObituary?.endDate);
        const extendedDate = new Date(endDate.getTime() + 30 * 24 * 60 * 60 * 1000);
        const currentTime = new Date();
        if (extendedDate < currentTime) {
          alert('해당 부고장은 발인 후 30일이 지나 만료되었습니다.');
          return false;
        }
      }
      return true;
    },

    isEndObituary() {
      if (this.getObituary?.endDate) {
        const endDate = new Date(this.getObituary?.endDate);
        const currentTime = new Date();

        return endDate < currentTime;
      }

      return this?.getObituary?.endFlag === "end";
    },

    skinBanner() {
      const skinBanner =
        this.obituaryDetail?.Corp?.SkinBanner ||
        this.obituaryDetail?.Funeral?.SkinBanner;

      const defaultBanner = {
        logoImg: null,
        backImg: null,
        fontImg: null,
        bannerList: []
      };

      if (!skinBanner) {
        return defaultBanner;
      }

      // 기본값 설정

      skinBanner.SkinBannerFiles.forEach(element => {
        switch (element.type) {
          case "logo":
            defaultBanner.logoImg = element;
            break;
          case "background":
            defaultBanner.backImg = element;
            break;
          case "font":
            defaultBanner.logoImg = defaultBanner.logoImg || element;
            defaultBanner.fontImg = element;
            break;
          default:
            defaultBanner.bannerList.push(element);
        }
      });

      return { ...skinBanner, ...defaultBanner };
    },

    encodeId() {
      return this.id && this.id.replace(" ", "+");
    }
  },
  mounted() {
    if (this.host === "admin") {
      alert(
        "관리자 전용 미리보기 페이지 입니다. 해당 링크를 직접 복사하지 마시고, 부고전달 버튼을 이용해서만 전달해주세요."
      );
    }

    this.$store
      .dispatch("REQUEST_OBITUARY_INFO", {
        id: JSON.stringify(this.$route.query.id),
        // 암호화 안 된 부고장 Number
        obituaryNo: this.$route.query.obituaryNo,
        memberId: this.$route.query.memberId
      })
      .then(data => {
        if (!data) {
          alert("존재하지 않는 부고장 입니다");

          return;
        }
        this.obituaryDetail = this.getObituary;
        this.dynamicTitle = `故 ${this.obituaryDetail.name}님의 부고장`;
        this.dynamicDescription = this.obituaryDetail.addrName;
        
        setTimeout(() => {
          this.loadingStatus = false;
        }, 1500);

        this.setupObituaryMembers();
      });
  },

  methods: {
    setupObituaryMembers() {
      const isOnlyCureentMemberView = this.obituaryDetail?.ObituaryMembers?.some(
        member => member.id === +this.memberId && member.familyType == "1"
      );

      if (isOnlyCureentMemberView) {
        this.obituaryMembers = this.obituaryDetail.ObituaryMembers.filter(
          member => member.id === +this.memberId
        ).map(member => ({
          type: member.memberType,
          value: [member.memberName, member.memberPhone],
          phoneYn: this.obituaryDetail.phoneYn
        }));
        return;
      }

      this.prepareObituaryMembers();
    },

    prepareObituaryMembers() {
      const sortedMembers = this.sortObituaryMembers(
        this.obituaryDetail.ObituaryMembers
      );
      this.obituaryMembers = this.buildObituaryMembersList(sortedMembers);
    },

    sortObituaryMembers(members) {
      return members.slice().sort((a, b) => {
        if (a.typeOrder === b.typeOrder) {
          return a.order - b.order;
        }
        return a.typeOrder - b.typeOrder;
      });
    },

    buildObituaryMembersList(sortedMembers) {
      const membersList = [];

      sortedMembers.forEach(member => {
        if (!member.syncFlag) return;

        const addName =
          member.memberName.trim() === "      " ? "빈빈빈" : member.memberName;
        const index = membersList.findIndex(m => m.type === member.memberType);
        if (index !== -1) {
          membersList[index].value[0] += `, ${addName}`;
          membersList[index].value[1] += `, ${member.memberPhone}`;
        } else {
          membersList.push({ type: member.memberType, value: [addName, member.memberPhone], phoneYn: this.obituaryDetail.phoneYn });
        }
      });

      return membersList;
    },

    async goShop() {
      //발인일이, 현재 시간 보다 과거일 경우도 막고 싶어
      if (this.obituaryDetail?.endFlag === "end") {
        alert("해당 부고는 발인 되어 주문이 불가능 합니다");
        return;
      }

      if (this.obituaryDetail?.endDate) {
        const endDate = new Date(this.obituaryDetail?.endDate);
        // Get the current time
        const currentTime = new Date();

        if (endDate < currentTime) {
          alert("해당 부고는 발인일이 지나 주문이 불가능 합니다");
          return;
        }
      }

      //if(this.obituaryDetail?.isShopOpen) {
      //  const phoneNum = '16882734';
      //  window.location.href = `tel:${phoneNum}`;
      //  return
      //}

      if (!this.encodeId) {
        const data = await this.$store.dispatch(
          "REQUEST_ENCODE",
          this.obituaryDetail.id
        );

        const encodeId = data.str;

        this.$router.push(
          `/shop?EcodeId=${encodeId}&memberId=${this.memberId}&mode=only`
        );

        return;
      }

      this.$router.push(
        `/shop?EcodeId=${this.encodeId}&memberId=${this.memberId}&bankOnly=${this.bankOnly}`
      );
    },

    handleAudioMute() {
      this.volumeMute = !this.volumeMute;
      const musicPlayer = this.$refs.musicplayer;
      if (this.volumeMute) {
        musicPlayer.pause();
      } else {
        musicPlayer.play();
      }
    },

    defualtMovieplayMusic() {
      const musicPlayer = this.$refs.musicplayer;
      musicPlayer.pause();
    }
  }
};
</script>
